import { useState } from 'react';

interface Props {
  nome: string;
  salvando: boolean;
  erro: string | null;
  aoConfirmar: (motivo: string | null) => void;
  aoFechar: () => void;
}

// Folha para dar a vaga a um suplente (motivo opcional).
export default function FolhaDarVaga({
  nome,
  salvando,
  erro,
  aoConfirmar,
  aoFechar,
}: Props) {
  const [motivo, setMotivo] = useState('');

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center sm:items-center sm:p-6">
      <div className="absolute inset-0 bg-black/30" onClick={aoFechar} aria-hidden />
      <div className="animate-modal-pop relative z-10 w-full max-w-md overflow-hidden rounded-t-3xl bg-white sm:rounded-3xl">
        <div className="flex items-start justify-between gap-3 border-b border-background-100 px-5 py-4">
          <div className="min-w-0">
            <h3 className="text-[17px] font-bold text-foreground-950">Dar a vaga a {nome.split(' ')[0]}?</h3>
            <p className="mt-0.5 text-[13px] text-foreground-600">
              A pessoa sai da fila de suplentes e passa a ter vaga.
            </p>
          </div>
          <button
            type="button"
            onClick={aoFechar}
            aria-label="Fechar"
            className="flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full text-foreground-500 transition-colors hover:bg-background-100"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <div className="px-5 py-4">
          <label className="text-[13px] font-medium text-foreground-800" htmlFor="motivo-dar-vaga">
            Motivo (opcional)
          </label>
          <input
            id="motivo-dar-vaga"
            type="text"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder="Ex.: desistência de outra pessoa"
            maxLength={120}
            className="mt-1 h-11 w-full rounded-xl border border-background-200 bg-white px-3 text-[15px] text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
          />
          {erro && (
            <p className="mt-3 rounded-xl bg-danger-50 px-3 py-2.5 text-[13px] text-danger-700">
              {erro}
            </p>
          )}
        </div>

        <div className="flex gap-2 border-t border-background-100 px-5 py-4">
          <button
            type="button"
            onClick={aoFechar}
            className="min-h-[46px] flex-1 cursor-pointer whitespace-nowrap rounded-full border border-secondary-300 bg-white px-4 text-[14px] font-semibold text-foreground-800 transition-colors hover:bg-background-100"
          >
            Voltar
          </button>
          <button
            type="button"
            onClick={() => aoConfirmar(motivo.trim() || null)}
            disabled={salvando}
            className="min-h-[46px] flex-1 cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-4 text-[14px] font-semibold text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {salvando ? 'Dando a vaga…' : 'Dar a vaga'}
          </button>
        </div>
      </div>
    </div>
  );
}